<script setup lang="ts">
import { CompareBuildingAgeResults, CommonApiResults } from "~/types/Facet";

const { isDesktop } = useDevice();

// 築年数と所在地のデフォルトの値を設定
const selectBuildingAge = ref(1);
const selectPrefId = ref(13);

const { $fireBangApiDomain, $commonApiDomain } = useNuxtApp();
// 試算表マスタAPI呼び出し
const { data: fetchBuildingAges } = await useFetch(`${$fireBangApiDomain}/api/compare/masters`, {
  key:'mainCompareLinkMasters',
  transform: (data: CompareBuildingAgeResults) => {
    // 築年数
    return data ? data.buildingAge : [];
  },
});

// 都道府県マスタAPI呼び出し
const { data: fetchPrefIds } = await useFetch(`${$commonApiDomain}/v3/prefs/`, {
  key:'mainCompareLinkPrefs',
  transform: (data: CommonApiResults) => {
    // 所在地
    return data ? data.response_json_body : [];
  },
});
</script>

<template>
  <div class="main-compare">
    <div class="main-compare-catch">
      条件を指定して<b>マンションの<br />保険料を比較</b>
    </div>
    <div class="main-compare-button">
      <div class="filter-item">
        <ul>
          <li class="buildingAgeYear">
            <span><b>築年数</b></span>
            <div>
              <select v-model="selectBuildingAge">
                <option
                  v-for="item in fetchBuildingAges"
                  :key="item.buildingAgeId"
                  :value="item.buildingAgeId"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </li>
          <li class="buildingPref">
            <span><b>所在地</b></span>
            <div>
              <select v-model="selectPrefId">
                <option value="">選択</option>
                <optgroup label="北海道・東北">
                  <option
                    v-for="item in fetchPrefIds?.slice(0, 7)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
                <optgroup label="関東">
                  <option
                    v-for="item in fetchPrefIds?.slice(7, 14)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
                <optgroup label="東海・甲信越・北陸">
                  <option
                    v-for="item in fetchPrefIds?.slice(14, 24)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
                <optgroup label="関西">
                  <option
                    v-for="item in fetchPrefIds?.slice(24, 30)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
                <optgroup label="中国・四国">
                  <option
                    v-for="item in fetchPrefIds?.slice(30, 39)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
                <optgroup label="九州・沖縄">
                  <option
                    v-for="item in fetchPrefIds?.slice(39, 47)"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </li>
        </ul>
        <a
          :href="
            '/compare/mansion/' +
            '?buildingAge=' +
            selectBuildingAge +
            '&prefId=' +
            selectPrefId +
            '#anchorFilterWrap'
          "
          class="button-step1"
        >
          <div>保険料を試算する</div></a
        >
      </div>
      <div class="main-compare-subButton">
        <a
          v-if="isDesktop"
          href="https://direct.nisshinfire.co.jp/oheya?a1=852911&a2="
          class="button-lease"
          target="_blank"
          rel="noopener"
          ><div>賃貸物件の方はこちら</div>
          <span>（外部サイト）</span></a
        >
        <a
          v-else
          href="https://direct.nisshinfire.co.jp/oheya?a1=852911&a2="
          class="button-lease"
          target="_blank"
          rel="noopener"
          ><div>賃貸物件の方はこちら</div>
          <span>（外部サイト）</span></a
        >
        <a href="/hojin/step/step_init.html" class="button-hojin"
          ><div>法人向け火災保険はこちら</div></a
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filter-item ul {
  display: none;
}

.button-step1 {
  margin: 0 auto 4.2%;
  padding: 4.4% 0;
  border-radius: 6px;
  width: 100%;
  display: block;
  color: #fff;
  font-weight: bold;
  background: url(~/assets/images/icon_building.png) no-repeat left 11% center
    $colorBasicButton;
  background-size: 9%;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  transition: 0.1s all;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.3);

  > {
    span {
      margin: 0 0.1em 0 0;
      padding: 0.2em 0.2em 0.3em;
      display: inline-block;
      color: #f00;
      font-size: px(17);
      font-weight: 700;
      background-color: #ff0;
      line-height: 1;
      vertical-align: middle;
    }

    div {
      width: 100%;
      display: inline-block;
      color: #fff;
      font-size: px(18.9);
      font-weight: 700;
      background: url(~/assets/images/arrow_orange_sp.png) no-repeat right 6.5%
        center;
      background-size: 8% auto;
      vertical-align: middle;
      text-shadow: 2px 2px 0px rgba(241, 90, 36, 0.4);
    }
  }
}

.button-lease {
  margin: 0 auto 3%;
  padding: 3% 0 3% 6%;
  border-radius: 4px;
  width: 93%;
  display: block;
  background: $colorSubButton url(~/assets/images/arrow_blue_sp.png) no-repeat
    right 4.4% center;
  background-size: 7.3% auto;
  text-align: left;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > div {
    margin: 0 auto;
    display: inline-block;
    color: $colorBlue;
    font-weight: 700;
  }

  span {
    margin: 0 0 0 -2%;
    display: inline-block;
    color: #333;
    font-size: px(9.9);
    font-weight: 400;
  }
}

.button-hojin {
  margin: 0 auto;
  padding: 3% 0 3% 6%;
  border-radius: 4px;
  width: 93%;
  display: block;
  background: $colorSubButton url(~/assets/images/arrow_blue_sp.png) no-repeat
    right 4.4% center;
  background-size: 7.3% auto;
  text-align: left;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  box-sizing: border-box;

  > div {
    margin: 0 auto;
    display: inline-block;
    color: $colorBlue;
    font-weight: 700;
  }
}

.main-compare {
  margin: 10% 4% 0;
  border: 4px solid $colorBlue;
  background-color: $colorBasicBackground;
}

.main-compare-catch {
  margin: 0.3em auto 0.5em;
  width: 15.6em;
  display: block;
  color: #fff;
  font-size: px(18);
  font-weight: 700;
  position: relative;
  text-align: center;
  text-shadow: 2px 2px 0 rgba(30, 134, 198, 0.4);

  &::before,
  &::after {
    content: '';
    width: 1px;
    height: 100%;
    display: block;
    background-color: #fff;
    position: absolute;
    top: 0;
  }

  &::before {
    left: 0;
    transform: rotate(-45deg);
  }

  &::after {
    right: 0;
    transform: rotate(45deg);
  }

  b {
    color: #fff800;
    font-weight: 700;
  }
}

.main-compare-button {
  padding: 5.3% 6.6% 8%;
  background-color: #fff;
  text-align: center;
}

@include media(pc) {
  select {
    border: none;
    width: 100%;
    padding: 7px 26px 7px 9px;
    appearance: none;
    background: url(~/assets/images/compare/select.png) no-repeat right center;
    background-size: 38px auto;
    cursor: pointer;
  }

  .filter-item {
    margin-bottom: 24px;
    display: flex;
    padding-bottom: 24px;
    border-bottom: 1px solid $colorBlue;

    ul {
      margin-right: 9px;
      display: flex;
      width: 262px;
      background: url(~/assets/images/arrow_right_cta.png) no-repeat right
        center;
    }

    li {
      border-radius: 4px;
      background-color: #fff;
      width: 104px;

      &.buildingAgeYear {
        margin-right: 12px;
      }

      span {
        padding: 3px 0;
        border-top: 1px solid $colorBlue;
        border-left: 1px solid $colorBlue;
        border-right: 1px solid $colorBlue;
        border-radius: 4px 4px 0 0;
        display: block;
        background-color: $colorBasicBackground;
        text-align: center;

        b {
          color: #fff;
          font-size: px(16);
          font-weight: bold;
        }
      }

      &.buildingAgeYear span b {
        padding: 0 0 0 20px;
        background: url(~/assets/images/compare/icon_building_ageyear.png)
          no-repeat left center;
        background-size: 16px 16px;
      }

      &.buildingPref span b {
        padding: 0 0 0 20px;
        background: url(~/assets/images/compare/icon_building_map.png)
          no-repeat left center;
        background-size: 12px 17px;
      }

      div {
        padding: 1px;
        border-bottom: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
        border-radius: 0 0 4px 4px;
      }

      &.buildingKind div {
        padding: 8px 5px;
        font-weight: bold;
        text-align: center;
        pointer-events: none;
      }

      div {
        &:hover {
          border-bottom: 1px solid $colorBlue;
          border-left: 1px solid $colorBlue;
          border-right: 1px solid $colorBlue;
          background-color: $colorSubBackground;
          box-shadow: 0 0 0 1px $colorBlue inset;
        }

        select {
          border-radius: 0 0 4px 4px;
        }
      }
    }
  }

  .button-step1 {
    margin: 0;
    padding: 16px 23px 0 27px;
    width: 320px;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);
    background: url(~/assets/images/icon_building.png) no-repeat left 27px
      center $colorBasicButton;
    background-size: 24px;

    &:hover {
      background-color: #f78c35;
    }

    > {
      span {
        margin: 0 0.5em 0 0;
        padding: 0.2em 0.2em 0.3em;
        font-size: px(19.9);
      }

      div {
        padding: 0;
        font-size: px(24);
        background: url(~/assets/images/arrow_orange_sp.png) no-repeat right
          center;
        background-size: 22px;
      }
    }
  }

  .button-lease {
    margin: 0 16px 0 0;
    padding: 16px 24px 16px 18px;
    width: 303px;
    background: $colorSubButton url(~/assets/images/arrow_blue_sp.png)
      no-repeat right 23px center;
    background-size: 20px;
    vertical-align: middle;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background: #efefef url(~/assets/images/arrow_blue_sp.png) no-repeat
        right 23px center;
      background-size: 20px;
    }

    > div {
      display: inline-block;
      font-size: px(16);
    }

    span {
      display: inline-block;
      font-size: px(12);
    }
  }

  .button-hojin {
    margin: 0;
    padding: 16px 21px 16px 22px;
    width: 263px;
    display: flex;
    align-items: center;
    background: $colorSubButton url(~/assets/images/arrow_blue_sp.png)
      no-repeat right 21px center;
    background-size: 20px;
    vertical-align: middle;
    box-shadow: 0px 4px 0px 0px rgba(0, 0, 0, 0.16);

    &:hover {
      background: #efefef url(~/assets/images/arrow_blue_sp.png) no-repeat
        right 21px center;
      background-size: 20px;
    }

    > div {
      margin: 0;
      font-size: px(16);
    }
  }

  .main-compare {
    margin: 70px 0 80px;
    border: 6px solid $colorBlue;
    border-radius: 4px;
  }

  .main-compare-catch {
    width: 83%;
    font-size: px(26);
    margin: 5px auto 14px;

    br {
      display: none;
    }

    &::before,
    &::after {
      content: '';
      width: 1px;
      height: 80%;
      display: block;
      background-color: #fff;
      position: absolute;
      top: 15%;
    }

    &::before {
      left: -0.4em;
      transform: rotate(-45deg);
    }

    &::after {
      right: -0.4em;
      transform: rotate(45deg);
    }

    b {
      color: #fff800;
      font-weight: 700;
    }
  }

  .main-compare-button {
    padding: 26px 23px 31px;
    background-color: #fff;
  }

  .main-compare-subButton {
    display: flex;
  }
}
</style>
